// Frontend mirror of backend/src/stepFlows.js — a deal picks one of three
// transaction step templates; each transaction carries its own `step_flow`
// snapshot, so every tracker/action here keys off the transaction, not the deal.

export const STEP_FLOWS = {
  pay_first: {
    steps: ['awaiting_payment', 'payment_confirmed', 'inspection_scheduled', 'awaiting_pickup', 'closed'],
    actor: { awaiting_payment: 'seller', payment_confirmed: 'buyer', inspection_scheduled: 'seller', awaiting_pickup: 'buyer' },
  },
  pay_first_no_inspection: {
    steps: ['awaiting_payment', 'payment_confirmed', 'awaiting_pickup', 'closed'],
    actor: { awaiting_payment: 'seller', payment_confirmed: 'seller', awaiting_pickup: 'buyer' },
  },
  pay_last: {
    steps: ['awaiting_inspection', 'inspection_scheduled', 'awaiting_pickup', 'awaiting_payment', 'closed'],
    actor: { awaiting_inspection: 'buyer', inspection_scheduled: 'seller', awaiting_pickup: 'buyer', awaiting_payment: 'seller' },
  },
};

export const FLOW_OPTIONS = [
  { id: 'pay_first',               label: 'Payment first — pay, inspect, pick up' },
  { id: 'pay_first_no_inspection', label: 'Payment first, no inspection — pay, pick up' },
  { id: 'pay_last',                label: 'Payment last — inspect, pick up, then pay' },
];

export const STEP_LABELS = {
  awaiting_payment:     'Awaiting Payment',
  payment_confirmed:    'Payment Confirmed',
  awaiting_inspection:  'Awaiting Inspection',
  inspection_scheduled: 'Inspection Scheduled',
  awaiting_pickup:      'Awaiting Pickup',
  closed:               'Closed',
  cancelled:            'Cancelled',
};

export function flowOf(id) {
  return STEP_FLOWS[id] || STEP_FLOWS.pay_first;
}

export function stepsFor(flowId) {
  return flowOf(flowId).steps;
}

export function nextStep(flowId, step) {
  const { steps } = flowOf(flowId);
  const i = steps.indexOf(step);
  return i >= 0 && i < steps.length - 1 ? steps[i + 1] : null;
}

export function actorFor(flowId, step) {
  return flowOf(flowId).actor[step] || null;
}

// Cancellation is available until the seller confirms payment — i.e. while the
// step is at or before 'awaiting_payment' in this flow's order.
export function cancellable(flowId, step) {
  const { steps } = flowOf(flowId);
  const i = steps.indexOf(step);
  const payIdx = steps.indexOf('awaiting_payment');
  return i >= 0 && payIdx >= 0 && i <= payIdx;
}
